

import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import { ServiceAutoComplete, Spinner } from 'triider-components';
import CardServiceCategory from 'components/CardServiceCategory';
import CardOpenOrders from 'components/CardOpenOrders';
import {
  Container,
  WelcomeUser,
  Content,
  ContentSubtitle,
  ContentOrders,
  ContentCategories,
  ContentSpinner,
  SearchContainer,
} from './styles';
import { Creators as FormCreators } from '../../store/ducks/serviceForm';
import { Creators as ServiceCreators } from '../../store/ducks/services';

function Home({
  companyId,
  addressUser,
  services,
  tasks,
  user,
  companySource,
  loadingVisible,
  _openForm,
  _getServiceByCity,
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 680);
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 680 && isMobile) {
        setIsMobile(false);
      } else if (window.innerWidth <= 680 && !isMobile) {
        setIsMobile(true);
      }
    }

    window.addEventListener('resize', handleResize);
    return function clean() {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  const listCategories = () => {
    const servicesList = [];
    if (services) {
      Object.entries(services).forEach(([key, value]) => {
        servicesList.push(
          <CardServiceCategory
            key={key}
            company={companySource}
            textService={key}
            services={value}
          />,
        );
      });
    }

    return servicesList;
  };

  const listTasks = () => {
    const tasksList = [];

    tasks.map(task => tasksList.push(<CardOpenOrders key={task.task_id} task={task} />));

    return tasksList;
  };

  const getServicesByCity = (city) => {
    _getServiceByCity(city);
  };

  const handleClick = (service) => {
    _openForm({
      isOpen: true,
      company_id: companyId,
      serviceId: service.id,
    });
  };

  return (
    <Container>
      {loadingVisible ? (
        <ContentSpinner>
          <Spinner size="larger" />
        </ContentSpinner>
      ) : (
        <Content>
          {isMobile && (
            <SearchContainer>
              {addressUser ? (
                <ServiceAutoComplete
                  isPartner
                  source={companySource}
                  onServiceSelected={handleClick}
                  onCitySelected={getServicesByCity}
                  initialCityObject={{
                    id: addressUser.id,
                    name: addressUser.name ? addressUser.name : 'Porto Alegre',
                    state_id: addressUser.state_id ? addressUser.state_id : 1,
                    state_name: addressUser.state_name
                      ? addressUser.state_name
                      : 'Rio Grande do Sul',
                    state_initials: addressUser.state_initials ? addressUser.state_initials : 'RS',
                  }}
                />
              ) : (
                <ServiceAutoComplete
                  isPartner
                  onCitySelected={getServicesByCity}
                  source={companySource}
                  onServiceSelected={handleClick}
                />
              )}
            </SearchContainer>
          )}
          {tasks.length > 0 && (
            <>
              <WelcomeUser marginBottom>Pedidos abertos</WelcomeUser>
              <ContentOrders>{listTasks()}</ContentOrders>
            </>
          )}
          {user && user.name && (
            <WelcomeUser>
              Olá,
              <span>
                &nbsp;
                {user.name}
              </span>
            </WelcomeUser>
          )}
          <ContentSubtitle>Primeiro, escolha o tipo de serviço que você precisa.</ContentSubtitle>
          <ContentCategories>{listCategories()}</ContentCategories>
        </Content>
      )}
    </Container>
  );
}

const mapStateToProps = state => ({
  services: state.services.data,
  companyId: state.company.data.id,
  loadingVisible: state.ui.loaders.includes('GETUSER'),
  companySource: state.company.data.source || '',
  user: state.auth.triiderUser && state.auth.triiderUser.user,
  addressUser: state.auth.triiderUser && state.auth.triiderUser.address,
  tasks: state.task.data,
});

const mapDispatchToProps = {
  _openForm: FormCreators.openForm,
  _getServiceByCity: ServiceCreators.getServicesByCityRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
